import * as React from 'react';
import glamorous from 'glamorous';
import { Query } from 'react-apollo';
import { RvLoader } from '../../components/Loader';
import gql from 'graphql-tag';
import { formatNumber, GetSuggestedMax, GetArrow, GetLeadsGroupBy, GetGroupByPlurals, convertStringNumberToNumber } from '../../helpers/ChartHelper';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { ChartCommonProps, IconButtonWrapper, ChartCommonState } from '../Common';
import { WithStyles, withStyles, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import MTooltip from '@material-ui/core/Tooltip';

import { Bar, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Scale,
    Tick,
    Chart,
    ChartEvent,
    ActiveElement,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { WithTranslation, withTranslation } from 'react-i18next';
import { TranslationTextList } from '../../locales/common';
import { HelpWrapper } from '../../home/Common';
import { ChartInfo } from '../../components/ChartInfo';
import { ChartFilter } from '../../home/ChartComponents';
import { AIIcon } from '../../components/icons/AIIcon';
import html2canvas from 'html2canvas';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../../home/chartTheme';
import { ChartHeading } from '../../home/ChartHeading';
import { ChartLimitNote } from '../../home/ChartLimitNote';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../../home/AnimatedNumber';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

// tslint:disable-next-line:no-any
const CardWrapper = glamorous.div<{ theme?: any }>(props => ({
    // padding: 15,
    display: 'flex',
    flexFlow: 'column',
    textAlign: 'center',
    // fontSize: '18px',
    height: '100%',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 14px 0 rgba(81,115,255,0.09)',
    width: '100%',
    '@media print': {
        alignItems: 'center',
    }
}));

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {

    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
    [`& .${`h3`}`]: {
        paddingTop: '10px'
    },
    '& .increase': {
        color: 'green',
    },
    '& .decrease': {
        color: 'red',
    }
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        }
    }
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

export enum NewLeadsEnum {
    All = 'All',
    AreaOfLaw = 'AreaOfLaw',
    Source = 'Source',
    Assignee = 'Assignee'
}

interface ChartProps extends ChartCommonProps, WithStyles<typeof styles>, WithTranslation {
    getSelectedItem?: (searchCriterias: Array<SearchCriteria>, isShowCompleted: boolean, title?: string) => void;
    periodInMonths: number;
    groupBy: string;
    chartFilter?: ChartFilter;
}

interface ChartState extends ChartCommonState {
    isBlobGenerating: boolean;
    isAIDialogOpen: boolean;
    base64Data: string | ArrayBuffer | null;
}

class NewLeadsInLast12MonthsByGroupChart extends React.Component<ChartProps, ChartState>  {

    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;
    private chartFilter: ChartFilter | undefined;
    public entireChartRef: React.RefObject<any> = React.createRef();

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onAIGeneratedSuggestion = this.onAIGeneratedSuggestion.bind(this);

        this.onPan = this.onPan.bind(this);

        this.chartRef = React.createRef();

        this.chartFilter = this.props.chartFilter;

        this.state = {
            open: false,
            anchorEl: undefined,
            isBlobGenerating: false,
            isAIDialogOpen: false,
            base64Data: null
        };
    }

    public componentDidMount() {
        // 
    }

    public componentWillUnmount() {
        // 
    }
    // tslint:disable-next-line: no-any
    public componentWillReceiveProps(nextProps: Readonly<ChartProps>, nextContext: any): void {
        if (this.props.chartFilter !== nextProps.chartFilter) {
            this.chartFilter = nextProps.chartFilter;
        }
    }

    public render() {
        
        const { groupBy, periodInMonths} = this.props;

        const { t } = this.props as {
            t: (key: keyof TranslationTextList) => string;
        };

        return (
            <div 
                ref={this.entireChartRef}
            >
                {this.state.isAIDialogOpen && (
                    <AIChartDialog 
                        fullWidth={true}
                        maxWidth="md"
                        open={this.state.isAIDialogOpen}
                        onClose={() => this.setState({ isAIDialogOpen: false })}
                        data={this.state.base64Data}
                        query={this.props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                        accessSubType={`NewLeadsInLast${this.props.periodInMonths}MonthsBy${this.props.groupBy}Chart`}
                        layoutId={this.props.layoutId}
                    />
                )}
                <CardWrapper>
                    {/* tslint:disable-next-line: no-any */}
                    <Query<any> 
                        query={ChartData}
                        variables={{                      
                            groupBy: groupBy,
                            entityType: this.chartFilter?.entityType,
                            entityGuid: this.chartFilter?.entityGuid,
                        }}

                    >
                        {({ loading, error, data }) => {

                            if (loading) {
                                return (
                                    <ChartSkeleton variant="bars" />
                                );
                            }

                            const statistics = data.statistics;

                            let lead = (loading || error ||
                                statistics === null || statistics === undefined)
                                ? null
                                : statistics.lead;

                            let newLeadsInLast12MonthsByGroup = lead ? lead.newLeadsInLast12MonthsByGroup : null;

                            if (newLeadsInLast12MonthsByGroup) {

                                const {
                                    groupedByCount,
                                    leadsPeriodTotalCount,
                                    groupedLeadsForLastPeriod
                                } = newLeadsInLast12MonthsByGroup;

                                const lastPeriodTotalCount = leadsPeriodTotalCount.lastPeriodTotalCount;
                                // tslint:disable-next-line:max-line-length
                                const previousPeriodTotalCount = leadsPeriodTotalCount.previousPeriodTotalCount;

                                // tslint:disable-next-line:no-any
                                let groupedBy = groupedLeadsForLastPeriod.map((value: any) => { return value.groupedBy; });

                                let highestValue = 0;
                                // tslint:disable-next-line: no-any
                                let lastPeriodCount = groupedLeadsForLastPeriod.map((value: any) => { 
                                    if (highestValue < value.lastPeriodCount) {
                                        highestValue = value.lastPeriodCount;
                                    }
                                    return value.lastPeriodCount; });
                                // tslint:disable-next-line: no-any
                                let previousPeriodCount = groupedLeadsForLastPeriod.map((value: any) => { 
                                    if (highestValue < value.previousPeriodCount) {
                                        highestValue = value.previousPeriodCount;
                                    }
                                    return value.previousPeriodCount; });  

                                return (
                                    <BarWrapper className={RV_CHART_CLASS}>
                                        <IconButtonWrapper
                                            aria-label="close"
                                        >
                                            <HelpWrapper className="rv-chart-help">
                                                <ChartInfo 
                                                    description={this.props.description}
                                                />
                                            </HelpWrapper>
                                            {this.props.isAIFeatureEnabled && (
                                                <MTooltip title="AI Assistant">
                                                    <IconButton 
                                                        disabled={this.state.isBlobGenerating}
                                                        size={'small'}
                                                        onClick={this.onAIGeneratedSuggestion}
                                                    >
                                                        <AIIcon 
                                                            color="primary"
                                                            fontSize={'medium'}
                                                        />
                                                    </IconButton>
                                                </MTooltip>
                                            )}
                                            <IconButton
                                                aria-label="close"
                                                onClick={this.onCloseChart}
                                                size="small"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </IconButtonWrapper>
                                        <BarTitleContainer>
                                            <ChartHeading icon={<InsertChartOutlinedIcon />} title={<>New {t('Enquiries')} in the last {periodInMonths} months</>} />
                                            <div className="h2">
                                                <AnimatedNumber value={lastPeriodTotalCount} format={(amount) => formatNumber(amount)} />
                                                {GetArrow(lastPeriodTotalCount, previousPeriodTotalCount)}
                                            </div>      
                                            <div className="h3">
                                                {formatNumber(previousPeriodTotalCount)} new {t('enquiries')} in the 12 months before that
                                            </div>                                      
                                            <div className="h3 rv-chart-section">New {t('Enquiries')} by {GetLeadsGroupBy(groupBy)}</div>
                                        </BarTitleContainer>
                                        <BarContainer className="rv-chart-bars">
                                            <Bar
                                                ref={this.chartRef}
                                                // tslint:disable-next-line: no-any
                                                onClick={(event: React.MouseEvent<any>) => {
                                                    const _data = getElementAtEvent(this.chartRef.current, event);
                                                    if (_data.length > 0 && this.props.getSelectedItem) {

                                                        // const _index = getElementAtEvent(this.chartRef.current, event)[0].index;

                                                        // const item = groupedBy[_index];

                                                        // const searchCriterias = new Array<SearchCriteria>();

                                                        // searchCriterias.push(
                                                        //     { property: groupBy, operator: 'eq', comparison: item },
                                                        //     //  tslint:disable-next-line: max-line-length
                                                        //     { property: 'InstructionDateStartByPeriod', operator: 'gteq', comparison: periodInMonths.toString() },
                                                        //     //  tslint:disable-next-line: max-line-length
                                                        //     { property: 'InstructionDateEndByPeriod', operator: 'lteq', comparison: periodInMonths.toString() }
                                                        // );

                                                        // return this.props.getSelectedItem(
                                                        //     searchCriterias,
                                                        //     false,
                                                        //     // tslint:disable-next-line: max-line-length
                                                        //     `New matters in the last ${periodInMonths} months by ${GetGroupBy(groupBy)}`
                                                        // );
                                                    }
                                                }}
                                                data={{
                                                    labels: groupedBy,
                                                    datasets: [
                                                        {
                                                            label: 'Previous 12 months',
                                                            ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft),
                                                            data: previousPeriodCount
                                                        },
                                                        {
                                                            label: 'Current 12 months',
                                                            ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                                            data: lastPeriodCount
                                                        }
                                                    ]
                                                }}
                                                options={{
                                                    onHover: this.onHover,
                                                    indexAxis: 'y' as const,
                                                    animation: rvChartAnimation(),
                                                    elements: { bar: { borderWidth: 0 } },
                                                    responsive: true,
                                                    maintainAspectRatio: false,
                                                    scales: {
                                                    x: {
                                                        grid: rvValueAxisStyle.grid,
                                                        // beginAtZero: true,
                                                        suggestedMax: GetSuggestedMax(highestValue),
                                                        beginAtZero: true,
                                                        ticks: {
                                                            ...rvValueAxisStyle.ticks,
                                                            autoSkip: false,
                                                            callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                return `${formatNumber(tickValue)}`;
                                                            }
                                                        }
                                                    },
                                                    y: {
                                                        grid: rvCategoryAxisStyle.grid,
                                                        // min: 0,
                                                        // max: 9 // minimum display
                                                        ticks: {
                                                            ...rvCategoryAxisStyle.ticks,
                                                            autoSkip: false
                                                        }
                                                    }
                                                    },
                                                    plugins: {
                                                    legend: {
                                                        position: 'bottom' as const,
                                                        display: true
                                                    },
                                                    title: {
                                                        display: false,
                                                        text: ``,
                                                    },
                                                    zoom: {
                                                        pan: {
                                                        enabled: false,
                                                        onPan: this.onPan
                                                        },
                                                        zoom: {
                                                        wheel: {
                                                            enabled: false
                                                        }
                                                        }
                                                        // limits: {
                                                        //   y: { min: 0, max: 9 },
                                                        // },
                                                    },
                                                    tooltip: {
                                                        ...rvTooltipStyle,
                                                        callbacks: {
                                                            // tslint:disable-next-line: no-any
                                                            label: function (context: any) {
                                                                const { 
                                                                    //   dataIndex, 
                                                                    //   label, 
                                                                    formattedValue,
                                                                    dataset 
                                                                } = context;

                                                                var currentValue = convertStringNumberToNumber(formattedValue);

                                                                return `${dataset.label}: ${formatNumber(currentValue)}`;
                                                            },
                                                        }
                                                    }
                                                    },
                                                }}
                                            />
                                        </BarContainer>
                                        {
                                            groupedByCount > 10 ?
                                                (<ChartLimitNote>The top 10 {GetGroupByPlurals(groupBy)} are shown</ChartLimitNote>) : undefined
                                        }
                                    </BarWrapper>
                                );
                            }

                            return (
                                <LoadWrapper className="load-wrapper">
                                    <RvLoader size="small" />
                                </LoadWrapper>
                            );
                        }}
                    </Query>
                </CardWrapper>
            </div>
        );
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart(`IsNewLeadsInLast${this.props.periodInMonths}MonthsBy${this.props.groupBy}ChartOpen`);
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue)
        });
    }

    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.x.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }

    private onAIGeneratedSuggestion = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        
        console.log('onAIGeneratedSuggestion', event);

        this.setState({ isBlobGenerating: true });

        if (this.entireChartRef && this.entireChartRef.current) {
            const canvas = await html2canvas(this.entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        this.setState({
                            base64Data: tempBase64data,
                            isAIDialogOpen: true
                        });
                    };
                }
            });
        }

        this.setState({ isBlobGenerating: false });

    }
}

// tslint:disable-next-line: no-any
export default withTranslation()(withStyles(styles as any, { withTheme: true })(NewLeadsInLast12MonthsByGroupChart as any) as any);

const ChartData = gql`query NewLeadsInLast12MonthsByGroupChartData($groupBy: NewLeadsGroupBy, $entityType: Int, $entityGuid: String) {
    statistics {
      lead {
        newLeadsInLast12MonthsByGroup(groupBy: $groupBy, entityType: $entityType, entityGuid: $entityGuid) {
          leadsPeriodTotalCount {
            lastPeriodTotalCount
            previousPeriodTotalCount
          }
          groupedLeadsForLastPeriod {
            groupedBy
            lastPeriodCount
            previousPeriodCount
          }
          groupedByCount
        }
      }
    }
  }
  `;
